import * as Sentry from "@sentry/vue"
import type {App} from "vue"
import type {Router} from "vue-router"

const ignoreErrorPatterns = [
  /Failed to fetch/i,
  /Load failed/i,
  /TelegramGameProxy/i,
  /Unable to preload CSS/i,
  /Method not found/i,
]

export default function initSentry(app: App<Element>, router: Router) {
  // https://docs.sentry.io/platforms/javascript/guides/vue/
  import.meta.env.VITE_SENTRY_ENABLED === "true" &&
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      debug: import.meta.env?.VITE_APP_MODE === "develop",
      environment: import.meta.env.VITE_APP_MODE,
      release: import.meta.env.VITE_APP_VERSION,
      integrations: [
        Sentry.browserTracingIntegration({router}),
        Sentry.replayIntegration({
          maskAllText: import.meta.env?.VITE_APP_MODE === "prod",
          stickySession: true,
        }),
        Sentry.captureConsoleIntegration({levels: ["error"]}),
        Sentry.httpClientIntegration({
          failedRequestStatusCodes: [500],
        }),
      ],
      sendDefaultPii: true,
      // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
      tracesSampleRate: 0,
      // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
      tracePropagationTargets: ["localhost", import.meta.env.VITE_BACK_API_URL],
      replaysSessionSampleRate: import.meta.env?.VITE_APP_MODE === "prod" ? 0 : 0.1,
      replaysOnErrorSampleRate: import.meta.env?.VITE_APP_MODE === "prod" ? 0 : 1,
      allowUrls: [
        "https://crm.shaketopay.st4g3.com",
        "https://crm.shaketopay.t3zt.com",
        "https://crm.expirenza.com",
      ],
      ignoreErrors: [
        "NetworkError when attempting to fetch resource",
        "Load failed",
        "Failed to fetch",
        "'text/html' is not a valid JavaScript MIME type",
        "Importing a module script failed",
      ],
      beforeSend(event, hint) {
        const error = hint.originalException
        if (
          error &&
          //@ts-expect-error expect message
          error.message &&
          //@ts-expect-error expect message
          ignoreErrorPatterns.some((p) => error.message.match(p)) > 0
        ) {
          return null
        }
        return event
      },
    })
}
